export default __webpack_public_path__ + "static/media/black-friday-2026-lettering.8b306ea4.png";